import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_bucket_list_data_by_id_action,
  get_bucketlist_candidate_data_action,
  get_all_interview_kit_data_action,
  assign_interview_to_bucket_list_data_action,
  send_bucket_by_email_data_action,
} from "../../../redux/_actions";
import { validateEmail } from "../../../_helpers/validators";
function useViewBucketList(props) {
  const [loadingBucketList, setLoadingBucketList] = useState(false);
  const [loadingAssessmentKit, setLoadingAssessmentKit] = useState(false);
  const [loadingCandidateList, setLoadingCandidateList] = useState(false);
  const [bucketListData, setBucketListData] = useState([]);
  const [assessmentKits, setAssessmentKits] = useState([]);
  const [candidatesData, setCandidatesData] = useState([]);
  const [assessmentKitsModal, setAssessmentKitsModal] = useState(false);
  const [bucketListId, setBucketListId] = useState(false);
  const [showShareBucketModal, setShowShareBucketModal] = useState(false);
  const [sharingBucketlistId, setSharingBucketlistId] = useState(null);
  const [emailId, setEmailId] = useState("");
  const [formError, setFormError] = useState();
  const [loadingShare, setLoadingShare] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { bucketListByIdData } = useSelector(
    (state) => state.get_bucket_list_data_by_id_reducer
  );

  const { bucketCandidatesData } = useSelector(
    (state) => state.get_bucketlist_candidate_data_reducer
  );
  const { allInterviewKitsData } = useSelector(
    (state) => state.get_all_interview_kit_data_reducer
  );

  useEffect(() => {
    const bucketId = params && params?.id;

    if (bucketId) {
      setBucketListId(bucketId);
      getBucketListData(bucketId);
      getAssessmentKits();
    }
  }, []);

  useEffect(() => {
    if (bucketListByIdData?.data) {
      setBucketListData(bucketListByIdData?.data);
    }
  }, [bucketListByIdData]);

  useEffect(() => {
    let data =
      bucketCandidatesData?.data && bucketCandidatesData?.data?.results;
    if (data) {
      setCandidatesData(data);
    }
  }, [bucketCandidatesData]);

  useEffect(() => {
    if (allInterviewKitsData?.data) {
      setAssessmentKits(allInterviewKitsData?.data);
    }
  }, [allInterviewKitsData]);

  const getBucketListData = async (id) => {
    setLoadingBucketList(true);
    await dispatch(get_bucket_list_data_by_id_action(id));
    setLoadingBucketList(false);
  };

  const getBucketListCandiatesData = async (id) => {
    setLoadingCandidateList(true);
    await dispatch(get_bucketlist_candidate_data_action(id));
    setLoadingCandidateList(false);
  };

  const getAssessmentKits = async () => {
    setLoadingAssessmentKit(true);
    await dispatch(get_all_interview_kit_data_action());
    setLoadingAssessmentKit(false);
  };

  const countTime = (data) => {
    let total_time = 0;
    Array.isArray(data) &&
      data.forEach((element) => {
        element?.questions &&
          element.questions.forEach((item) => {
            total_time = item?.time_to_answer + total_time;
          });
      });
    return total_time;
  };
  const countQuestions = (data) => {
    let total_question = 0;
    Array.isArray(data) &&
      data.forEach((element) => {
        total_question =
          Array.isArray(element?.questions) &&
          element?.questions &&
          element.questions.length + total_question;
      });
    return total_question;
  };

  const onViewCandidatesClick = (interviewKit) => {
    navigate(`/submitted-candidates-assessments/${interviewKit}`);
  };

  const onClickEditAssessment = (id) => {
    navigate(`/create-assessment/${id}`);
  };

  const onViewCandidateProfileClick = (id) => {
    if (id) navigate(`/view-candidate-profile/${id}`, { state: id });
  };

  const onViewAssessmentClick = (interview_kit, applicantId) => {
    navigate(
      `/view-assessment-video?interviewKit=${interview_kit}&applicant=${applicantId}`
    );
  };

  const handleCloseAssessmentModal = (type) => {
    setAssessmentKitsModal(type);
  };

  const checkExitingAssessment = (item) => {
    if (item) {
      let itemIndex =
        Array.isArray(
          bucketListData && bucketListData.assigned_assessments_details
        ) &&
        bucketListData &&
        bucketListData.assigned_assessments_details.findIndex(
          (obj) => obj?.id === item
        );
      return itemIndex >= 0;
    }
  };

  const onClickAddAssementToBucket = async (kitId) => {
    const bucketId = params && params?.id;

    if (bucketId) {
      const data = {
        bucket_list: bucketId,
        interview_kit: kitId,
      };
      const res = await dispatch(
        assign_interview_to_bucket_list_data_action(data)
      );

      if (res && res.msg) {
        getBucketListData(bucketId);
        handleCloseAssessmentModal(false);
      }
    }
  };
  const handleBackClick = () => {
    navigate(-1);
  };

  const tabChangesHandler = () => {
    if (bucketListId) {
      getBucketListCandiatesData(bucketListId);
      getBucketListData(bucketListId);
    }
  };

  const shareBucketModalHandler = async (type, id) => {
    if (type) {
      setShowShareBucketModal(type);
      setSharingBucketlistId(id);
    } else {
      setShowShareBucketModal(type);
      setSharingBucketlistId(null);
      setEmailId("");
    }
  };
  const shareBucketListByEmail = async () => {
    let errorData = {};
    if (emailId === "") {
      errorData.emailId = "Please Enter Email Id";
    }
    if (!validateEmail(emailId)) {
      errorData.emailId = "Please Enter Valid Email Id";
    }

    setFormError(errorData);

    if (!Object.keys(errorData).length) {
      const data = {
        email: emailId,
        bucket_list: sharingBucketlistId,
      };
      setLoadingShare(true);
      const res = await dispatch(send_bucket_by_email_data_action(data));
      setLoadingShare(false);
      if (res.detail) shareBucketModalHandler(false);
    }
  };

  return {
    loadingBucketList,
    loadingAssessmentKit,
    loadingCandidateList,
    candidatesData,
    bucketListData,
    assessmentKits,
    assessmentKitsModal,

    showShareBucketModal,
    shareBucketModalHandler,
    setEmailId,
    formError,
    shareBucketListByEmail,
    loadingShare,

    countTime,
    onViewCandidatesClick,
    countQuestions,
    onClickEditAssessment,
    onViewCandidateProfileClick,
    onClickAddAssementToBucket,
    checkExitingAssessment,
    handleCloseAssessmentModal,
    handleBackClick,
    tabChangesHandler,
    onViewAssessmentClick,
  };
}
export default useViewBucketList;
